import timeoutModal from '@/services/timeoutModal.vue';

export default {
  install(Vue, options) {
    var context = null;
    Vue.mixin({
      created() {
        context = this;
      }
    })

    var callback = () => { };
    Vue.prototype.$timeout = {
      Open: (logoutTime, logoutRedirect) => {
        context.$buefy.modal.open({
          component: timeoutModal,
          canCancel: false,
          props: {
            "time": logoutTime,
            "go": logoutRedirect,
            "defaultTime": options.defaultTimeout,
            "defaultPath": options.defaultRedirect
          },
          events: {
            close: (result) => {
              callback(result);
            }
          }
        });
      },
      SetCallback: (fn) => {
        callback = fn;
      }
    }
  }
}

